import { onlineManager } from '@tanstack/react-query';

import { onlineCatalogsRepositoryOfflineAdapters } from '../../offline/offlineRequestAdapters/onlineCatalogs.repository.offlineAdapters';
import { onlineCatalogsRepository } from './onlineCatalogs.repository';

export const catalogsRepository = (id: string, isOfflineMode = false) =>
  isOfflineMode || !onlineManager.isOnline()
    ? onlineCatalogsRepositoryOfflineAdapters(id)
    : onlineCatalogsRepository(id);
